import React from "react";
import { useTradeInAemSelector } from "../../../redux/store";
import * as Styles from "../common/styles/ResultsAem";
import { ImageFluid } from "../../../../common-deprecated/styles/v2/toyota/globals/Image";
import { getModelImage } from "../../../utils/utils";
import { TradeInAemLabel, tradeInAemModelSelectLabels } from "../../../utils/labels";

const TradeInAemSummaryModelBlock = (): JSX.Element | null => {
    const commonSettings = useTradeInAemSelector((state) => state.commonSettings);
    const modelList = useTradeInAemSelector((state) => state.tradeInAemModelSelect.modelList);
    const selectedModelId = useTradeInAemSelector((state) => state.tradeInAemModelSelect.selectedModelId);
    const selectedCarType = useTradeInAemSelector((state) => state.tradeInAemModelSelect.selectedCarType);
    const selectedModel = modelList.find((listItem) => listItem.id === selectedModelId);

    if (!selectedCarType) return null;

    const ccisImage = selectedModel
        ? getModelImage(selectedModel, commonSettings, {
              type: "png",
              bgColour: "",
              width: 1042,
              height: 411,
              padding: "0,0,0,0",
              scaleMode: 1,
          })
        : "";

    return (
        <>
            <Styles.Title>
                <TradeInAemLabel label="tradeInAemSummaryCustomerIntention" />
            </Styles.Title>
            {selectedModel && (
                <Styles.Card>
                    <Styles.CardImage>
                        <ImageFluid src={ccisImage} />
                    </Styles.CardImage>
                    <Styles.CardBody px={{ sm: 4, lg: 4 }}>{selectedModel.cheapestCar?.model.name}</Styles.CardBody>
                </Styles.Card>
            )}
            {selectedCarType && (
                <Styles.Card>
                    <Styles.CardBody>
                        <Styles.List>
                            <dt>
                                <TradeInAemLabel label="tradeInAemSummaryBuyingIntention" />
                            </dt>
                            <dd>
                                <TradeInAemLabel label={tradeInAemModelSelectLabels[selectedCarType]} />
                            </dd>
                        </Styles.List>
                    </Styles.CardBody>
                </Styles.Card>
            )}
        </>
    );
};
export default TradeInAemSummaryModelBlock;
